import { Button } from 'antd';
import React, { useCallback, useState } from 'react'
import { CompressOutlined, ExpandOutlined } from "@ant-design/icons"
import "./lesson.css";

export default function Lesson({ states }) {
    const [state, setState] = useState(0);
    const [expanded, setExpaned] = useState(false);
    const [nextState, setNextState] = useState(false);
    const nextHandle = useCallback(() => {
        setState(prev => {
            if (prev >= states.length - 1) {
                return states.length - 1;
            }
            return prev + 1
        })
        setNextState(false);
    }, [states])

    const CurrentState = states[state];

    return <div className={expanded ? "expand" : ""} style={{ 
            padding: 10,
            position: "relative"
        }}>
        <CurrentState nextState={nextState} setNextState={setNextState}/>
        {nextState && (state < states.length - 1) && <div style={{ textAlign: 'right' }}>
            <Button type='primary' onClick={nextHandle}>
                Sang nội dung
            </Button>
        </div>}
        <Button style={{
            position: "absolute",
            right: 5,
            top: 5,
        }} type='primary' onClick={() => {
            setExpaned(!expanded);
        }}>
            {expanded ? <CompressOutlined /> : <ExpandOutlined />}
        </Button>
    </div>
}
